import { Formik, Form } from 'formik';
import DotLoader from "react-spinners/BeatLoader";
import { CompanyForm , XInput } from '../../../../components';
import { EditCompanyValidationSchema } from '../../../../utils/companyUtils';
import useCompanyForm from '../../../../hooks/useCompanyForm';
import SubscriptionDetails from '../../../../components/SubscriptionDetails';
import { COMPANY_STATUS, dateToInput, getDBName, STATES } from '@demandproai/shared';
import XButton from '../../../../components/common/XButton';
import PageTitle from '../../../../components/common/PageTitle';

const sectionHeaderClasses = "flex justify-between items-center w-full mr-4";

const EditCompaniesForm = ({ selectedUser, isSubmittingForm: toggleIsSubmittingForm }) => {
  const {isloader,onback, onSubmitEditCompany} = useCompanyForm(toggleIsSubmittingForm);
  return (
    <>
      <Formik
        initialValues={{
          companyName: selectedUser?.companyName || '',
          companyPhonenumber: selectedUser?.companyPhoneNumber || '',
          // companyemail: selectedUser?.companyEmail || '',
          companyAddress: selectedUser?.companyAddress || '',
          firstName: selectedUser?.firstName || '',
          contactPhonenumber: selectedUser?.contactNumber || '',
          lastName: selectedUser?.lastName || '',
          emailAddress: selectedUser?.contactEmail || '',
          domainName: selectedUser?.domainName ? getDBName(selectedUser.domainName) : '',
          databaseIp: selectedUser?.databaseIp || '',
          taxId: selectedUser?.taxId || '',
          databaseUser: selectedUser?.databaseUser || '',
          companyLogo: selectedUser?.companyLogo || "",
          ContractDetails: selectedUser?.ContractDetails || "",
          accountantname: selectedUser?.accountantname || "",
          accountantemail: selectedUser?.accountantEmail || [],
          status: selectedUser?.status || COMPANY_STATUS.TRIAL,
          isDelayedPayment: selectedUser?.isDelayedPayment || false,
          usersLimit: selectedUser?.subscription?.usersLimit || 0,
          monthlyPrice: selectedUser?.subscription?.monthlyPrice || 0,
          demandsPerMonth: selectedUser?.subscription?.demandsPerMonth || 0,
          remainingDemand: selectedUser?.subscription?.remainingDemand || 0,
          rollOverCredits: selectedUser?.subscription?.rollOverCredits || 0,
          costPerAdditionalDemand: selectedUser?.subscription?.costPerAdditionalDemand || 0,
          chargeAdditionalPlaintiffs: selectedUser?.subscription?.chargeAdditionalPlaintiffs ?? true,
          subscriptionRenewalDate: dateToInput(selectedUser?.subscription?.subscriptionRenewalDate),
          contractRenewalDate: dateToInput(selectedUser?.subscription?.contractRenewalDate),
          costPerAdditionalUser: selectedUser?.subscription?.costPerAdditionalUser || 0,
          tier:selectedUser.tier || '',
          tierNotes:selectedUser.tierNotes || '',
          startedOn: dateToInput(selectedUser?.startedOn),
          accountExecutive: selectedUser.accountExecutive || '',
          commission: selectedUser.commission ?? 0,
          isAnnual: selectedUser.isAnnual ?? false,
          hsCompanyId:selectedUser.hsCompanyId || '',
          homeState: selectedUser?.homeState ?? STATES[0].value,
        }}
        enableReinitialize={true}
        validationSchema={EditCompanyValidationSchema}
        onSubmit={(values) => {
          onSubmitEditCompany(values, selectedUser._id);
        }}
      >
        {( formik ) => (
          <Form>
            <div className="p-0!">
              <div className="row items-center">
                <div className="col-md-6">
                  <PageTitle title="Company Information" />
                </div>
                <div className="col-md-6 flex justify-end">
                  <XButton onClick={() => onback()}><i className='fa fa-arrow-left mr-2!'></i> Back to Companies</XButton>
                </div>
              </div>
              <h2>
                <div className={sectionHeaderClasses}>
                  <span>Company Details</span>
                </div>
              </h2>
              <div className="row">
                <CompanyForm formik={formik}/>
                <SubscriptionDetails formik={formik}/>
                <h2>
                  <div className={sectionHeaderClasses}>
                    <span>Current Month Usage</span>
                  </div>
                </h2>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className="form-group">
                      <XInput name="remainingDemand"   label="Remaning Demands of the month" {...formik.getFieldProps("remainingDemand")} />
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className="form-group">
                      <XInput name="rollOverCredits"   label="Rollover credits" {...formik.getFieldProps("rollOverCredits")} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="btns text-right">
                <XButton variant="outlinePrimary" className="mr-3!" onClick={() => onback()}>Cancel</XButton>
                <XButton type="submit">Update</XButton>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      <DotLoader
        color="var(--color-primary)"
        loading={isloader}
        size={30}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </>
  );
};
export default EditCompaniesForm;
